import React from 'react';
import DataVizTool from '../data_viz/DataVizTool';
import { DATA_VIZ_LEVELS as LEVELS_1, DATA_VIZ_CHALLENGES as CHALLENGES_1, validateAnswer as validate_1 } from './config/dataVizChallenges';
import { DATA_VIZ_LEVELS as LEVELS_2, DATA_VIZ_CHALLENGES as CHALLENGES_2, validateAnswer as validate_2 } from './config/dataViz2Challenges';
import { DATA_VIZ_LEVELS as LEVELS_3, DATA_VIZ_CHALLENGES as CHALLENGES_3, validateAnswer as validate_3 } from './config/dataViz3Challenges';
import { DATA_VIZ_LEVELS as LEVELS_INTRO, DATA_VIZ_CHALLENGES as CHALLENGES_INTRO, validateAnswer as validate_intro } from './config/dataVizIntroChallenges';
import { DATA_VIZ_LEVELS as LEVELS_INTERMEDIATE, DATA_VIZ_CHALLENGES as CHALLENGES_INTERMEDIATE, validateAnswer as validate_intermediate } from './config/dataVizIntermediateChallenges';
import { DATA_VIZ_METADATA } from './DataVizIndex';

const DataVizModule = ({ moduleId = 'DATA_VIZ_1' }) => {
    // Determine which configuration to load based on moduleId
    const isModule2 = moduleId === 'DATA_VIZ_2';
    const isModule3 = moduleId === 'DATA_VIZ_3';
    const isModuleIntro = moduleId === 'DATA_VIZ_INTRO';
    const isModuleIntermediate = moduleId === 'DATA_VIZ_INTERMEDIATE';

    let challenges = isModuleIntermediate ? CHALLENGES_INTERMEDIATE
        : isModuleIntro ? CHALLENGES_INTRO
        : isModule3 ? CHALLENGES_3
        : isModule2 ? CHALLENGES_2
        : CHALLENGES_1;

    let levels = isModuleIntermediate ? LEVELS_INTERMEDIATE
        : isModuleIntro ? LEVELS_INTRO
        : isModule3 ? LEVELS_3
        : isModule2 ? LEVELS_2
        : LEVELS_1;

    let validator = isModuleIntermediate ? validate_intermediate
        : isModuleIntro ? validate_intro
        : isModule3 ? validate_3
        : isModule2 ? validate_2
        : validate_1;

    let metadata = DATA_VIZ_METADATA.find(m => m.id === moduleId.toLowerCase());

    return (
        <DataVizTool
            key={moduleId}
            moduleId={moduleId}
            DATA_VIZ_CHALLENGES={challenges}
            DATA_VIZ_LEVELS={levels}
            validateAnswer={validator}
            moduleMetadata={metadata}
            allModules={DATA_VIZ_METADATA}
        />
    );
};

export default DataVizModule;
